import { seprateNumberFromComma } from "common/method/seprateNumberFromComma";

export const handleNull = (value) => {
	if (
		!value ||
		value === "null" ||
		value === null ||
		value === undefined ||
		value === "NULL"
	) {
		return "-";
	}
	return value;
};

export const handleNullFalse = (value) => {
	return (
		!value ||
		value === "null" ||
		value === null ||
		value === undefined ||
		value === "NULL"
	);
};

export const handleNumber = (value, ToFixNum) => {
	if (+value === 0) {
		return 0;
	}
	if (!value || value === "null") {
		return "-";
	} else if (typeof value !== "number") {
		return value;
	}
	if (ToFixNum) {
		return parseFloat(value.toFixed(ToFixNum)).toLocaleString();
	}
	return parseFloat(value.toFixed(2)).toLocaleString();
};

export const handleNumberTofixed4 = (value) => {
	if (+value === 0) {
		return 0;
	}
	if (!value || value === "null") {
		return "-";
	} else if (typeof value !== "number") {
		return value;
	}
	return parseFloat(value.toFixed(4)).toLocaleString();
};
export const handleNumberTofixed2 = (value) => {
	if (+value === 0) {
		return 0;
	}
	if (!value || value === "null" || value === Infinity || value === -Infinity ) {
		return "-";
	} else if (typeof value !== "number") {
		return value;
	}
	return parseFloat(value.toFixed(2)).toLocaleString();
};

export const handleStatus = (value) => {
	switch (value) {
		case "SUBMITTED":
			return "در انتظار";
		case "REJECTED":
			return "لغو شده";
		case "FINALIZED":
			return "نهایی شده";
		default:
			return "نامشخص";
	}
};

export const handleIsActive = (value) => {
	switch (value) {
		case "TRUE":
			return "فعال";
		case "FALSE":
			return "غیر فعال";
		default:
			return "نامشخص";
	}
};

export const handleUnit = (item, flag) => {
	const value = 0;
	if (flag === "unit") return "میلیون";
	if (flag === "value") return value;
	return "-";
};
export const getvalueRefomated = (maxVal) => {
	if (maxVal > 1000000000000) {
		return seprateNumberFromComma(maxVal / 1000000000000);
	} else if (maxVal > 1000000000) {
		return seprateNumberFromComma(maxVal / 1000000000);
	} else if (maxVal > 1000000) {
		return seprateNumberFromComma(maxVal / 1000000);
	}
	return seprateNumberFromComma(maxVal);
	// return parseFloat(value.toFixed(2)).toLocaleString();
};
export const getUnitStringFromMaxVal = (maxVal) => {
	if (maxVal > 1000000000000) {
		return "همت";
	} else if (maxVal > 1000000000) {
		return "میلیارد تومان";
	} else if (maxVal > 1000000) {
		return "میلیون تومان";
	}
	return "تومان";
	// return parseFloat(value.toFixed(2)).toLocaleString();
};
